export default __webpack_public_path__ + "static/media/東京視頻.25cf6e24.png";